import { tv } from "tailwind-variants";
const inputVariants = tv({
  slots: {
    root: "group transition duration-300 relative flex has-[:invalid]:border-red-500 has-[:disabled]:bg-slate-100 has-[:disabled]:cursor-not-allowed has-[:focus]:border-blue-600 border-[1px] border-slate-300 rounded-lg min-h-5xl size-0 px-xl py-sm items-center gap-2 w-full",
    input: "transition bg-transparent duration-300 block cursor-text resize-none caret-blue-600 pb-2.5 pt-6 size-full text-b3 text-slate-900 disabled:text-slate-400 disabled:cursor-not-allowed appearance-none focus:outline-none focus:ring-0 peer z-10",
    label: "transition z-10 absolute !text-b3 peer-placeholder-shown:text-b2 peer-focus-visible:text-b3 text-slate-500 duration-300 transform -translate-y-4 top-5 peer-disabled:text-slate-400 peer-disabled:cursor-not-allowed peer-placeholder-shown:cursor-text peer-focus:pointer-events-none peer-placeholder-shown:top-4 peer-focus:top-5 origin-[0] start-4 peer-invalid:text-red-500 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-4",
    prefixIcon: "transition duration-300 size-5 peer-disabled:hidden invisible group-has-[:focus]:visible pt-1",
    suffixIcon: "transition duration-300 size-5 peer-disabled:hidden w-auto self-center"
  },
  variants: {
    error: {
      true: {
        root: "!border-red-500",
        label: "!text-red-500"
      }
    },
    success: {
      true: {
        root: "!border-green-600 !bg-green-100"
      }
    }
  }
});
export {
  inputVariants as default
};
